import React from 'react'
import './Refractory.css'
import drag from './image/drag.jpg'
import redler from './image/redler-chain.jpg'

const Refractory = () => {
  return (
    <div>
      <div className="refractoryp">
        <p className="p">Refractory Industry</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Refractory Industry</p> */}
        </div>
      </div>

    <div className="refractory">
      <div className="rimg">
        <figure>
          <img src={drag} alt="Ash Chain"/>
          <figcaption>Drag Enmass Conveyor Chain</figcaption>
        </figure>
      </div>

      <div className="rimg">
        <figure>
          <img src={redler} alt="Drag Chain"/>
          <figcaption>Redler Chain</figcaption>
        </figure>
      </div>

      </div>


    </div>
  )
}

export default Refractory
